module.exports = __webpack_public_path__ + "img/EWMA-District-Logo-Transparent@1x.5da846da.png";